import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseProvider } from '../BaseProvider';
import { RateAlertModel, BaseRateModel } from '../../_models/index';
import { GlobalService } from '../../_global/global.service';

@Injectable()
export class RateService extends BaseProvider {

    getrates = 'rates/current';
    resource = 'rates/';
    getrateslead = 'rates/';
    urlRateRange = 'pricing/rateRange?product=##PRODUCT##&currencyCode=##CURRENCYCODE##&partnerId=##PARTNERID##&sellType=##SELLTYPE##&purpose=##PURPOSE##';
    urlGetQuotes = 'invoices';
    // urlEmailQuotes = 'b2c/quotations';
    urlEmailQuotes = 'quotations';
    urlGetLiveIBR = 'rates/ibr';
    urlGetCustomIBR = 'rates/ibrCorrected';
    urlGetCustomIBRHistory = 'rates/ibrCorrectedHistory';
    urlPostCustomIBR = 'rates/ibrCorrected';
    urlDeleteCustomIBR = 'rates/ibrCorrected/##CURRENCYCODE##';
    urlGetPartnerComission = 'pricing/commissions?rate=##RATE##&currencyAmount=##CURRENCYAMOUNT##&currencyCodes=##CURRENCYCODE##&partnerId=##PARTNERID##&product=##PRODUCT##&sellType=##SELLTYPE##&commissionPerUnit=##TOTALCOMMISSIONPERUNIT##&agentCommissionPerUnit=##PARTNERCOMMISSIONPERUNIT##&purpose=##PURPOSE##'

    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
    }

    getRateRange(productId: string, currencyCode: string, sellType: string, partnerId: string) { // Get Current Forex Rates
        let url = this.urlRateRange.replace('##PRODUCT##', productId)
            .replace('##CURRENCYCODE##', currencyCode)
            .replace('##PARTNERID##', partnerId)
            .replace('##SELLTYPE##', sellType)
        return this.makeGetCall(url);
    }

    getRateRangeWithIssuer(productId: string, currencyCode: string, sellType: string, partnerId: string, purpose: string, issuer: string) { // Get Current Forex Rates
        return this.makeGetCall("pricing/rateRange?product=" + productId + "&currencyCode=" + currencyCode + "&partnerId=" + partnerId + "&sellType=" + sellType + "&purpose=" + purpose + "&issuer=" + issuer);
    }

    getRateRangeWithPurpose(productId: string, currencyCode: string, sellType: string, partnerId: string, purpose: string) { // Get Current Forex Rates
        let url = this.urlRateRange.replace('##PRODUCT##', productId)
            .replace('##CURRENCYCODE##', currencyCode)
            .replace('##PARTNERID##', partnerId)
            .replace('##SELLTYPE##', sellType)
            .replace('##PURPOSE##', purpose)
        return this.makeGetCall(url);
    }

    // /alert?userID=1cd2c68c8da041e79159a0b14861e936
    getCurrentRate(productId: string) { // Get Current Forex Rates
        return this.makeGetCall(this.getrates + '?products=' + productId);
    }

    // /alert?userID=1cd2c68c8da041e79159a0b14861e936
    getCurrentRateforAllProducts() { // Get Current Forex Rates
        return this.makeGetCall(this.getrates + '?partnerId=' + this._gs.currentUser.partner.id);
    }

    getCurrentRateforAllProductsByPartnerId(partnerId) { // Get Current Forex Rates
        return this.makeGetCall(this.getrates + '?partnerId=' + partnerId);
    }

    getCurrentRateTopX(productId: string) { // Get Current Forex Rates
        return this.makeGetCall(this.getrates + '?currencyCodes=AED,EUR,USD,THB,CAD,AUD&product=' + productId);
    }

    getCurrentRates(productId: string) { // Get Current Forex Rates
        //return this.makeGetCall(this.getrateslead + 'current' + '?productId=' + partnerId);
        return this.makeGetCall(this.getrateslead + 'current');
    }

    getTopRates(currencyArray: string[]) { // Get Current Forex Rates of the currencies passed
        return this.makeGetCall(this.resource + "current" + "?" + encodeURIComponent(currencyArray.toString()));
    }

    getRatesAlerts() { // Get Forex Rates Alerts
        return this.makeGetCall(this.resource + "alert?userID=" + this._gs.currentUser.id);
    }

    setRateAlert(rateAlertRequest: RateAlertModel[]) { // set Forex Rate Alert\
        return this.makePostCall(this.resource + "alert", rateAlertRequest);
    }

    getEarning(baseRate: BaseRateModel) {
        this.resource = '/pricing/rateRange?productId=' + baseRate.productId +
            '&currencyCode=' + baseRate.currencyCode + '&partnerId=' + baseRate.partnerId;
        return this.makeGetCall(this.resource);
    }

    getQuote(orders: any) {
        return this.makePostCall(this.urlGetQuotes, orders);
    }

    emailQuote(orders: any) {
        return this.makePostCall(this.urlEmailQuotes, orders);
    }

    postInitiateQuotationLimitOtp(reqBody) {
        return this.makePostCall("initiateQuotationsLimitOtp", reqBody)
    }
    postValidateQuotationsLimitOtp(reqBody) {
        return this.makePostCall("validateQuotationsLimitOtp", reqBody)
    }

    getLiveIbrRates() {
        return this.makeGetCall(this.urlGetLiveIBR);
    }
    getThirdPartyRate() {
        return this.makeGetCall('thirdPartyRates/rules');
    }
    getThirdPartyEmail(emailIds, id: any) {
        return this.makePostCall('thirdPartyRates/publish?emailIds=' + emailIds, id);

    }
    getCustomIBRRates() {
        return this.makeGetCall(this.urlGetCustomIBR);
    }

    postCustomIBRRates(rates: any) {
        return this.makePostCall(this.urlPostCustomIBR, rates);
    }

    deleteCustomIBRRates(currencyCode: any) {
        let url = this.urlDeleteCustomIBR.replace('##CURRENCYCODE##', currencyCode)
        //console.log(url);
        return this.makeDeleteCall(url);
    }

    getIBRRatesHistory(currencies: string[]) {
        return this.makeGetCall(this.urlGetCustomIBRHistory + "?currencyCodes=" + encodeURIComponent(currencies.toString()));
    }

    getPartnerComission(partnerId: any, product: any, sellType: any, currencyCodes: any, currencyAmount: any, rate: any, totalCommissionPerUnit: any, PartnerCommissionPerUnit: any, purpose: any) {
        let url = this.urlGetPartnerComission.replace('##RATE##', rate)
            .replace('##CURRENCYAMOUNT##', currencyAmount)
            .replace('##CURRENCYCODE##', currencyCodes)
            .replace('##PARTNERID##', partnerId)
            .replace('##PRODUCT##', product)
            .replace('##SELLTYPE##', sellType)
            .replace('##TOTALCOMMISSIONPERUNIT##', totalCommissionPerUnit)
            .replace('##PARTNERCOMMISSIONPERUNIT##', PartnerCommissionPerUnit)
            .replace('##PURPOSE##', purpose);
        // console.log(url);
        return this.makeGetCall(url);
    }

    updateThirdPartyRates(rates) {
        return this.makePostCall('thirdPartyRates/rules', rates);
    }
    getPdfExcel(fileExtention: string) {
        return this.makeGetCall('thirdPartyRates/' + fileExtention).map(res => res.arrayBuffer())
        // return this.makeGetCall('thirdPartyRates/' + fileExtention);
    }
    getPdf(fileExtention: string) {
        return this.makeGetCall('thirdPartyRates/' + fileExtention).map(res => res.arrayBuffer())
        // return this.makeGetCall('thirdPartyRates/' + fileExtention);
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/rates/rate.service.ts